import React from "react";
import { GabcSyllabified } from "gabc-utils";

import Exsurge, { SharedExsurgeProps } from "./Exsurge";
import { GabcSyllabifiedOptions } from "gabc-utils/dist/lib/GabcSyllabified";

export interface SyllabifiedExsurgeProps extends SharedExsurgeProps {
  text: string;
  notation: string;
  isEasterTime?: GabcSyllabifiedOptions['isEaster'];
  removeSolesmesMarkings?: GabcSyllabifiedOptions['removeSolesmesMarkings'];
  repeatVerses?: GabcSyllabifiedOptions['repeatVerses'];
  followedByGabc?: GabcSyllabifiedOptions['followedByGabc'];
  language?: GabcSyllabifiedOptions['language'];
  refrainAtBeginning?: GabcSyllabifiedOptions['refrainAtBeginning'];
  tildeReplacement?: GabcSyllabifiedOptions['tildeReplacement'];
}

const SyllabifiedExsurge: React.FC<SyllabifiedExsurgeProps> = ({
  text,
  notation,
  isEasterTime,
  removeSolesmesMarkings,
  repeatVerses,
  followedByGabc,
  language,
  refrainAtBeginning,
  tildeReplacement,
  ...otherProps
}: SyllabifiedExsurgeProps) => {
  const gabc = GabcSyllabified.merge(
    text,
    notation,
    {
      isEaster: isEasterTime,
      removeSolesmesMarkings,
      repeatVerses,
      followedByGabc,
      language,
      refrainAtBeginning,
      tildeReplacement,
      useLargeInitial: otherProps.useDropCap,
    },
  );

  return <Exsurge gabc={gabc} alignment={language === 'la' ? 'latin' : 'english'} {...otherProps}/>;
};

export default SyllabifiedExsurge;
